import _ from "lodash";
import moment from "moment";

import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import { getSubscriptionId } from "../utilities/utils";

/**
 * Retrieves the count of candidate types using the provided data.
 *
 * @param {Object} data - The data to be sent with the request
 * @return {Promise} The count of candidate types
 */
export const _candidatetypeCount = async (data) => {
  // 'bookedView' => $bookedView, 'workedView' => $workedView

  const request = {
    endPoint: serviceRouteConstants.candidateTypeCount,
    data: {
      ...data,
      bookedView: data.bookedView ? data.bookedView : "shifts",
      WorkedView: data.WorkedView ? data.WorkedView : "contracts",
    },
  };
  return await post(request);
};

/**
 * Shifts the calendar using the provided data.
 *
 * @param {object} data - the data for shifting the calendar
 * @return {Promise} the result of the post request
 */
export const _shiftCalendar = async (data) => {
  let shiftDateFrom = data.shiftDateFrom;
  let shiftDateTo = data.shiftDateTo;
  if (shiftDateFrom && !_.isEmpty(shiftDateFrom)) {
    shiftDateFrom = moment(shiftDateFrom, "DD-MM-YYYY").format("YYYY-MM-DD");
  }
  if (shiftDateTo && !_.isEmpty(shiftDateTo)) {
    shiftDateTo = moment(shiftDateTo, "DD-MM-YYYY").format("YYYY-MM-DD");
  }

  let subscription_id = getSubscriptionId();

  const postData = {
    date: data.date ? data.date : moment().format("YYYY-MM-DD"),
    type: data.type ? data.type : "year",
    status: data.status ? data.status : "",
    // numRecord: data.numRecord ? data.numRecord : 0,
    for: data.for ? data.for : "",
    search: data.search ? data.search : "",
    page: data.currentPage ? data.currentPage : 1,
    candidate_reference_no: data.candidateReferenceNo,
    candidate_name: data.candidateName,
    licence_no: data.candidateLicenseNo,
    contract_reference_no: data.contractReferenceNo,
    role: data.candidateRole,
    phone_number: data.candidatePhoneNumber,
    candidate_compliance_status: data.complianceStatus,
    shift_date_from: shiftDateFrom,
    shift_date_to: shiftDateTo,
    subscription_id: subscription_id,
  };

  const request = {
    endPoint: serviceRouteConstants.shiftCalendar,
    data: postData,
  };
  return await post(request);
};

/**
 * Retrieves upcoming bookings for a client.
 *
 * @param {Object} data - The data for the request
 * @return {Promise} The result of the request
 */
export const _upcomingBookings = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.upComingBookings,
    data: data,
  };
  return await post(request);
};
